export default __webpack_public_path__ + "static/vivacom_logo_positive-b52d55f477bf9316b0d627bfcf0a2f64.png";